/**
 * Maps a `TenantCase.type` onto its display name and route.
 *
 * These cannot be derived by lowercasing the type: the routes are
 * German product names, so `DepositCase` lives at `/kaution` and
 * `GeneralTenantCase` at `/mietrechtsanfragen`.
 */
const CASE_TYPE_ROUTES: Record<string, { label: string; path: string }> = {
  Mietminderung: { label: "Mietminderung", path: "/mietminderung" },
  Mietendeckel: { label: "Mietendeckel", path: "/mietendeckel" },
  Mietpreisbremse: { label: "Mietpreisbremse", path: "/mietpreisbremse" },
  GeneralTenant: { label: "Mietrechtsanfrage", path: "/mietrechtsanfragen" },
  OperatingCost: { label: "Nebenkosten", path: "/nebenkosten" },
  Deposit: { label: "Kaution", path: "/kaution" },
};

export const resolveCaseType = (
  type?: string | null,
): { label: string; path: string } => {
  const key = type?.replace("Case", "") ?? "";
  return (
    CASE_TYPE_ROUTES[key] ?? {
      label: key || "Fall",
      path: `/${key.toLowerCase()}`,
    }
  );
};
